import React from "react";

import { Grid } from "@material-ui/core";
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';

import CakeRoundedIcon from '@mui/icons-material/CakeRounded';
import BadgeRoundedIcon from '@mui/icons-material/BadgeRounded';
import MaleRoundedIcon from '@mui/icons-material/MaleRounded';
import FemaleRoundedIcon from '@mui/icons-material/FemaleRounded';
import TransgenderRoundedIcon from '@mui/icons-material/TransgenderRounded';
import LocalPhoneRoundedIcon from '@mui/icons-material/LocalPhoneRounded';

import { formatDateDDMMYYYY } from "../../../plas/utils";

export default function Profile({ user, roles }) {
 
  const getGenderIcon = () => {
    if (user.userProfile.isMan())
      return (<MaleRoundedIcon/>);
    else if (user.userProfile.isWoman())
      return (<FemaleRoundedIcon/>);
    else
      return (<TransgenderRoundedIcon/>);
  }

  return (
    <Grid container spacing={2} >
      <Grid item xs={12} sm={8}>
         <TextField
          variant="outlined" 
          id="id"
          label="Nombre y apellido"
          name="id"
          fullWidth
          InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <BadgeRoundedIcon />
            </InputAdornment>
            ),
          }}
          value={`${user.userProfile.name} ${user.userProfile.lastName}`}
        />
      </Grid>
      <Grid item xs={6} sm={4} >
        <TextField
          variant="outlined" 
          id="role"
          label="Fecha de nacimiento"
          name="role"
          fullWidth
          InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <CakeRoundedIcon />
            </InputAdornment>
            ),
          }}
          value={`${formatDateDDMMYYYY(user.userProfile.getBirthDate())}`}/>
      </Grid>
      <Grid item xs={6} sm={4} >
        <TextField
          variant="outlined" 
          id="gender"
          label="Genero"
          name="gender"
          fullWidth
          InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              { getGenderIcon() }
            </InputAdornment>
            ),
          }}
          value={user.userProfile.getGenderName()} />
      </Grid>
      { user.userProfile.phoneNumber && (
        <Grid item xs={6} sm={4} >
          <TextField
            variant="outlined" 
            id="phoneNumber"
            label="Número telefónico"
            name="phoneNumber"
            fullWidth
            InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <LocalPhoneRoundedIcon/>
              </InputAdornment>
              ),
            }}
            value={user.userProfile.phoneNumber} />
        </Grid>
      )}
    </Grid>
  );
}

